import React, { useState, useEffect } from 'react';
import { Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from 'reactstrap';
import Select from 'react-select';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addWorkOrder, fetchAddressesRequest, fetchCustomersRequest, getCatalogItems, getSebelUsers, getShifts, getSolutions, getTeams } from 'store/actions';
import { FaEdit, FaFileContract, FaFilter, FaHashtag, FaPhoneAlt, FaUserCircle } from 'react-icons/fa';
import { RiContractLine } from 'react-icons/ri';
import DUMMY_USER_IMG from '../../assets/images/dummyUser.jpg';
import axiosInstance from 'pages/Utility/axiosInstance';
import Breadcrumb from 'components/Common/Breadcrumb2';
import toast from 'react-hot-toast';
import { ClipLoader } from 'react-spinners';
import { formatDate, formatTime } from 'helpers/dateFormat_helper';
import Cookies from 'js-cookie';
import { addMinutesToTime } from 'helpers/common_helper';
import { fetchSolutionByUser } from 'helpers/commonDataFetching';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-datepicker';
import "../../assets/scss/customerDatePicker.css";
import { duration } from 'moment';
import { Skeleton } from 'antd';

// CreateWorkOrder component
const CreateWorkOrder = () => {
    const [customerType, setCustomerType] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [addressCards, setAddressCards] = useState([]);
    const [profileData, setProfileData] = useState();
    const [catelogueItems, setCatalogueItems] = useState();
    const [workOrderItems, setWorkOrderItems] = useState([]);
    const [selectedCatalogItem, setSelectedCatalogItem] = useState(null);
    const [itemQuantity, setItemQuantity] = useState('');
    const [scheduledStartDateTime, setScheduledStartDateTime] = useState('');
    const [agentComments, setAgentComments] = useState('');
    const [remedyNumber, setRemedyNumber] = useState('');
    const [customerInvoicePath, setCustomerInvoicePath] = useState('')
    const [selectedShift, setSelectedShift] = useState(null);
    const [invoiceFile, setInvoiceFile] = useState(null);
    const [solutions, setSolutions] = useState([])
    const [availableSlots, setAvailableSlots] = useState(null);
    const [totalTime, setTotalTime] = useState();
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [modal, setModal] = useState(false);
    const [highlightedSlot, setHighlightedSlot] = useState(null);
    const [base64InvoiceFile, setBase64InvoiceFile] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedSolution, setSelectedSolution] = useState();
    const [searchFields, setSearchFields] = useState({ contractNumber: "", contactNumber: "", name: "" });
    const [customer, setCustomer] = useState();
    const [customers, setCustomers] = useState();
    const [serialNumber, setSerialNumber] = useState();
    const error = useSelector(state => state?.WorkOrder?.error)
    const workOrders = useSelector(state => state?.WorkOrder?.workorders)
    const loading = useSelector(state => state?.WorkOrder?.loading);
    const [team, setTeam] = useState();
    const [selectedTime, setSelectedTime] = useState();
    const [tempTime, setTempTime] = useState();
    const [selectedDate, setSelectedDate] = useState(null);
    const [sebelUserId, setSebelUserId] = useState();
    const [slotLoading, setSlotLoading] = useState(false);
    const [calendarLoading, setCalendarLoading] = useState(false);
    const [loader, setLoader] = useState(true);
    const [isCustomersLoading, setIsCustomersLoading] = useState(false);
    const [isCatalogLoading, setIsCatalogLoading] = useState(false);
    const [isSolutionsLoading, setIsSolutionsLoading] = useState(false);

    const permissions2 = JSON.parse(localStorage?.getItem('permissions'));

    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const addresses = useSelector((state) => state.Address.addresses);
    // const catalogItems = useSelector((state) => state.Catalog.catalogItems);
    const [catalogItems, setCatalogItems] = useState();
    const shifts = useSelector((state) => state?.Shift?.shifts);
    const sebelUsers = useSelector((state) => state.SebelUser.users);
    const shiftsLoading = useSelector((state) => state?.Shift?.loading);
    const sebelUsersLoading = useSelector((state) => state.SebelUser.loading);
    const loading2 = useSelector((state) => state?.Shift?.loading);
    const [checkSubmit, setCheckSubmit] = useState(false);
    const [uniqueTeams, setUniqueTeams] = useState();
    const [bookedDates, setBookedDates] = useState()
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const authUser = JSON.parse(Cookies.get('authUser'));
    const userId = JSON.parse(Cookies.get('authUser'))?.userId
    const id = queryParams.get('id');
    const [serialNumbers, setSerialNumbers] = useState([]);
    const [modalSerialNoOpen, setModalSerialNoOpen] = useState(false);
    if (!permissions2?.map(item => item?.permissionName)?.includes("Add Work Orders")) {
        navigate('/pages-403')
    }

    const isBooked = date =>
        bookedDates?.map(item => new Date(item.EngagedDate))?.some(
            booked => booked?.toDateString() === date?.toDateString()
        );

    // Handle Serial Number Change
    const handleSerialNumberChange = (index, value) => {
        const updatedSerialNumbers = [...serialNumbers];
        updatedSerialNumbers[index] = value;
        setSerialNumbers(updatedSerialNumbers);
    };

    // Validate Serial Numbers
    const validateSerialNumbers = () => {
        const uniqueSerials = new Set(serialNumbers);
        if (serialNumbers?.some(item => !item)) {
            return showError("Please provide all serial numbers")
        }
        if (uniqueSerials.size !== serialNumbers.length) {
            showError("All serial numbers must be unique.");
            return false;
        }

        return true;
    };

    // Handle Confirm Serial Numbers and Add Item
    const handleConfirmSerialNumbers = () => {
        if (validateSerialNumbers()) {
            const newItem = {
                id: selectedCatalogItem?.value,
                catalogItem: selectedCatalogItem,
                estimatedTime: selectedCatalogItem?.estimatedTime * itemQuantity,
                quantity: itemQuantity,
                perTime: selectedCatalogItem?.estimatedTime,
                serialNumbers: serialNumbers?.join(","), // Store all entered serial numbers
                image: selectedCatalogItem?.image,
                sku: selectedCatalogItem?.sku,
                model: selectedCatalogItem?.model,
            };

            setWorkOrderItems([...workOrderItems, newItem]);
            setScheduledStartDateTime('');
            setModalSerialNoOpen(false);
            resetForm();
        }
    };

    // Handle Add Work Order Item
    const handleAddWorkOrderItem = () => {
        if (!selectedCatalogItem) return alert("Please select a catalog item!");
        if (!itemQuantity || itemQuantity <= 0) return alert("Please enter a valid quantity!");

        // Check if item already exists
        if (workOrderItems?.some(item => item.id === selectedCatalogItem?.value)) {
            return showError("Catalogue item already exists!");
        }

        // If serial number is required, open modal
        if (selectedCatalogItem?.isRequired) {
            setSerialNumbers(new Array(Number(itemQuantity)).fill(""));
            setModalSerialNoOpen(true);
        } else {
            // Add item without serial numbers
            const newItem = {
                id: selectedCatalogItem?.value,
                catalogItem: selectedCatalogItem,
                estimatedTime: selectedCatalogItem?.estimatedTime * itemQuantity,
                quantity: itemQuantity,
                perTime: selectedCatalogItem?.estimatedTime,
                serialNumbers: "",
                image: selectedCatalogItem?.image,
                sku: selectedCatalogItem?.sku,
                model: selectedCatalogItem?.model,
            };

            setWorkOrderItems([...workOrderItems, newItem]);
            setScheduledStartDateTime('');
            resetForm();
        }
    };

    // Reset Form
    const resetForm = () => {
        setSelectedCatalogItem(null);
        setItemQuantity("");
        setSerialNumbers([]);
    };

    useEffect(() => {
        if (catalogItems?.Data?.length > 0) {
            const groupedByCategory = catalogItems?.Data?.reduce((acc, item) => {
                const { categoryName, itemName, catalogueId, estimatedInstallTimeInMins, isSerialNumberRequired, image, sku, model } = item;

                // Check if the category already exists in the accumulator
                if (!acc[categoryName]) {
                    acc[categoryName] = [];
                }

                // Push the item into the respective category
                acc[categoryName].push({
                    value: catalogueId,
                    label: itemName,  // label as the catalogueId (string)
                    estimatedTime: estimatedInstallTimeInMins,
                    isRequired: isSerialNumberRequired,
                    image: image,
                    sku: sku,
                    model: model
                });

                return acc;
            }, {});

            // Step 2: Create the desired options array
            const optionsArray = Object.keys(groupedByCategory).map((categoryName) => {
                return {
                    label: categoryName,  // Use category name as label
                    options: groupedByCategory[categoryName],  // Use the grouped items as options
                };
            });
            setCatalogueItems(optionsArray);
        }
    }, [catalogItems]);

    const fetchCustomers = async () => {
        setIsCustomersLoading(true);
        try {
            const response = await axiosInstance?.get('', { params: { sp: "usp_SearchCustomer", customerNameEng: searchFields?.name, contactNumber: searchFields?.contactNumber, contractNumber: searchFields?.contractNumber } });
            if (response) {
                setCustomers(response?.data)
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsCustomersLoading(false);
        }
    }

    const fetchCatalogItems = async () => {
        setIsCatalogLoading(true);
        try {
            const response = await axiosInstance?.get('', { params: { sp: "usp_GetCatalogueBySolutionId", solutionId: selectedSolution } });
            if (response) {
                setCatalogItems(response?.data)
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsCatalogLoading(false);
        }
    }

    useEffect(() => {
        if (loading2) return;
        dispatch(getShifts())
        dispatch(getSebelUsers())
    }, [dispatch]);

    const fetchSolutionByUser = async (id) => {
        setIsSolutionsLoading(true);
        try {
            const response = await axiosInstance(`${process.env.REACT_APP_BASE_URL_TWO}usp_GetSolutionsByUserId`, { params: { userId: id } });
            setSolutions(response?.data)
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.log(error)
        } finally {
            setIsSolutionsLoading(false);
        }
    }

    useEffect(() => {
        fetchSolutionByUser(JSON.parse(Cookies.get('authUser'))?.userId);
    }, [])

    useEffect(() => {
        if (selectedSolution) {
            setCatalogueItems([])
            setCatalogItems([])
            setWorkOrderItems([]);
            fetchCatalogItems();
        }
    }, [selectedSolution])

    useEffect(() => {
        fetchCustomers();
    }, [searchFields])

    useEffect(() => {
        if (addresses?.Data?.length > 0) {
            setAddressCards(addresses?.Data);
        }
    }, [addresses]);

    useEffect(() => {
        if (id && customers?.Data?.length > 0) {
            setCustomerType("existing");
            const selectedCustomer = customers.Data.find(customer => customer.customerId == id);
            if (selectedCustomer) {
                setCustomer({
                    value: selectedCustomer.customerId,
                    label: selectedCustomer.customerNameEng,
                })
                setSelectedCustomer({
                    value: selectedCustomer.customerId,
                    label: selectedCustomer.customerNameEng,
                });
            }
        }
    }, [id, customers?.Data]);

    const handleCustomerTypeChange = (e) => {
        if (e.target.value === 'new') {
            navigate(`/createCustomer`, { state: { from: window.location.pathname } })
        }
        setCustomerType(e.target.value);
        setSelectedCustomer(null);
        setAddressCards([]);
        setSelectedAddress(null);
        setProfileData(null);
        setModalOpen(true)

    };

    const fetchCustomer = async (id) => {
        const response = await axiosInstance.get('', { params: { sp: 'usp_GetCustomerById', customerId: id } });
        setProfileData(response?.data?.Data?.[0]);
    };

    const showSuccess = (msg) => {
        toast.dismiss();
        toast.success(msg)
    }

    const showError = (msg) => {
        toast.dismiss();
        toast.error(msg)
    }

    const toggleCustomerModal = () => {
        setModalOpen(!modalOpen);
        setCustomerType("")
    }

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchFields((prev) => ({ ...prev, [name]: value }));
    };

    // Filter customers based on search fields
    const handleSearch = () => {
        const { contractNumber, contactNumber, name } = searchFields;
        let filtered = customers?.Data?.filter((customer) => {
            return (
                (!contractNumber || customer.contractNumber?.includes(contractNumber)) &&
                (!contactNumber || customer.contactNumber?.includes(contactNumber)) &&
                (!name || customer.customerNameEng?.toLowerCase().includes(name.toLowerCase()))
            );
        });
    };

    // Handle customer selection inside modal
    const handleCustomerSelect = (selected) => {
        setCustomer(selected);
    };

    const handleCustomerSelectSubmit = () => {
        setSelectedCustomer(customer);
        setModalOpen(false);
    }

    useEffect(() => {
        if (selectedCustomer) {
            dispatch(fetchAddressesRequest(selectedCustomer?.value));
            fetchCustomer(selectedCustomer?.value);
        } else {
            setAddressCards([]);
            setProfileData(null);
        }
    }, [selectedCustomer, dispatch]);

    const handleAddressSelect = (address) => {
        setSelectedAddress(address.customerAddressId === selectedAddress?.customerAddressId ? null : address);
    };

    // const handleAddWorkOrderItem = () => {
    //     if (selectedCatalogItem && itemQuantity) {
    //         if (workOrderItems?.filter(item => item?.id == selectedCatalogItem?.value)?.length === 1) {
    //             showError("Catalogue item already exists")
    //         } if (selectedCatalogItem?.isRequired && !serialNumber) {
    //             showError("Serial Number is required")
    //         } else {
    //             const newItem = { id: selectedCatalogItem?.value, catalogItem: selectedCatalogItem, estimatedTime: selectedCatalogItem?.estimatedTime * itemQuantity, quantity: itemQuantity, perTime: selectedCatalogItem?.estimatedTime, serialNumber: serialNumber || "", image: selectedCatalogItem?.image, sku: selectedCatalogItem?.sku, model: selectedCatalogItem?.model };
    //             setWorkOrderItems([...workOrderItems, newItem]);
    //             setSelectedCatalogItem(null);
    //             setItemQuantity('');
    //             setSerialNumber('');
    //             setSelectedSlot(null);
    //             setSelectedTime(null);
    //             setHighlightedSlot(null)
    //         }
    //     } else if (!selectedCatalogItem) {
    //         showError("Please select a catalog item !")
    //     } else if (!itemQuantity) {
    //         showError("Please enter the quantity")
    //     }
    // };

    const handleDeleteWorkOrderItem = (id) => {
        setWorkOrderItems(workOrderItems.filter((item) => item.id !== id));
        setSelectedSlot(null);
        setSelectedTime(null);
        setHighlightedSlot(null);
        setScheduledStartDateTime('');
    };

    // handle invoice
    const handleInvoiceFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.type === 'application/pdf') {
                // Create a new FileReader instance
                const reader = new FileReader();

                reader.onload = () => {
                    const base64File = reader.result;
                    setInvoiceFile(file);
                    setCustomerInvoicePath(file.name);
                    setBase64InvoiceFile(base64File);
                };

                reader.readAsDataURL(file);
            } else {
                toast.error('Please upload a valid PDF file.');
            }
        }
    };

    // Validation function
    const validateForm = () => {
        const newErrors = {};
        const currentDateTime = new Date();
        if (!selectedSolution) newErrors.solution = "Please select a solution"
        if (!sebelUserId) newErrors.sebelUserId = "Sebel userId is required"
        if (!customerType) newErrors.customerType = "Please select a customer type.";
        if (customerType === 'existing' && !selectedCustomer) showError("Please select a customer");
        if (!selectedAddress) newErrors.selectedAddress = "Please select an address.";
        if (workOrderItems.length === 0) newErrors.workOrderItems = "Please add at least one work order item.";
        if (!scheduledStartDateTime) {
            newErrors.scheduledStartDateTime = "Please select a start date";
        } else if (new Date(scheduledStartDateTime).setHours(0, 0, 0, 0) < currentDateTime.setHours(0, 0, 0, 0)) {
            newErrors.scheduledStartDateTime = "You cannot select a past date as start date";
        }
        if (!selectedShift) newErrors.selectedShift = 'Please select a shift.';
        if (!invoiceFile) newErrors.customerInvoicePath = 'Please upload the invoice PDF.';
        if (!remedyNumber) newErrors.remedyNumber = 'Remedy Number is required.';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        if (checkSubmit) {
            validateForm();
        }
    }, [selectedSolution, sebelUserId, selectedCustomer, selectedAddress, workOrderItems, scheduledStartDateTime, selectedShift, invoiceFile])

    const formattedWorkOrderItems = {
        items: workOrderItems.map(item => ({
            catalogueId: item.catalogItem.value,
            quantity: parseInt(item.quantity),
            serialNumber: item?.serialNumbers
        }))
    };

    /// submit form
    const handleSubmit = async () => {
        setCheckSubmit(true)
        if (validateForm()) {
            // Submit the form
            if (selectedTime) {
                dispatch(addWorkOrder({
                    sp: "usp_InsertWorkOrder",
                    customerID: selectedCustomer?.value,
                    totalEstimatedTimeInMins: workOrderItems?.reduce((sum, item) => sum + item?.estimatedTime, 0),
                    createdBy: userId,
                    customerAddressId: selectedAddress?.customerAddressId,
                    teamId: highlightedSlot?.teamId,
                    scheduledStartDateTime: formatDate(
                        `${scheduledStartDateTime instanceof Date
                            ? scheduledStartDateTime.toLocaleDateString("en-CA") //  local YYYY-MM-DD
                            : scheduledStartDateTime}T${selectedTime}:00`
                    ),
                    scheduledEndDateTime: formatDate(
                        new Date(
                            `${scheduledStartDateTime instanceof Date
                                ? scheduledStartDateTime.toLocaleDateString("en-CA") // local YYYY-MM-DD
                                : scheduledStartDateTime}T${selectedTime}:00`
                        ).getTime() + (workOrderItems?.reduce((sum, item) => sum + item?.estimatedTime, 0) * 60000)
                    ),
                    agentComments: agentComments,
                    remedyNumber: remedyNumber,
                    customerInvoicePath: base64InvoiceFile,
                    workOrderItems: JSON.stringify({ items: formattedWorkOrderItems?.items }),
                    solutionId: selectedSolution,
                    sabelUserId: sebelUserId
                }, navigate));

            } else {
                showError("Please select a slot")
            }

        } else {
            if (!selectedAddress && selectedCustomer) {
                showError("Please Select an address")
            }
            console.log(errors)
        }
    };

    // clear form after submission
    useEffect(() => {
        setCustomerType('');
        setCustomer(null);
        setCustomers([]);
        setSelectedCustomer(null);
        setSelectedAddress(null);
        setAddressCards([]);
        setProfileData(null);
        setCatalogueItems([]);
        setWorkOrderItems([]);
        setSelectedCatalogItem(null);
        setItemQuantity('');
        setSerialNumber('');
        setScheduledStartDateTime('');
        setSelectedShift('')
        setAgentComments('');
        setRemedyNumber('');
        setCustomerInvoicePath('');
        setInvoiceFile(null);
        setBase64InvoiceFile('');
        setErrors({});
        setHighlightedSlot("")
        setAvailableSlots([])
        setSebelUserId("")
        setSelectedSolution("")
    }, [workOrders])

    // fetching available slots
    const fetchAvailableSlots = async () => {
        setSlotLoading(true);
        try {
            const response = await axiosInstance.get('', { params: { sp: "usp_GetShiftTeamAvailability", shiftId: selectedShift?.value ? selectedShift?.value : null, scheduledDate: scheduledStartDateTime ? scheduledStartDateTime : null, solutionId: selectedSolution, customerId: selectedCustomer?.value } });
            if (response) {
                setAvailableSlots(response?.data?.Data);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setSlotLoading(false);
        }
    }

    useEffect(() => {
        if (scheduledStartDateTime && selectedShift && selectedSolution && selectedCustomer) {
            fetchAvailableSlots();
        }
    }, [scheduledStartDateTime, selectedShift, selectedSolution, selectedCustomer])


    const toggleModal = () => setModal(!modal);

    const handleSlotClick = (team, slot) => {
        setTeam(team);
        if (workOrderItems?.length <= 0) {
            showError("Please select at least one catalogue item")
        } else {
            setSelectedSlot({ team, slot });
            setTempTime("")
            toggleModal();
        }
    };

    const handleTimeChange = (e) => {
        setTempTime(e.target.value);
    };

    useEffect(() => {
        setSelectedTime(undefined);
        setHighlightedSlot(null);
    }, [scheduledStartDateTime, selectedSolution]);

    const fetchCalenderShow = async () => {
        setCalendarLoading(true);
        try {
            const response = await axiosInstance.get(``, { params: { sp: "usp_GetAvailableSlotsByTime", shiftId: selectedShift?.value, requiredDuration: totalTime, solutionId: selectedSolution, customerId: selectedCustomer?.value } });
            setBookedDates(response?.data?.Data);
        } catch ({ error }) {
            console.log(error)
        } finally {
            setCalendarLoading(false);
        }
    }

    useEffect(() => {
        if (workOrderItems?.length > 0) {
            const totalMinutes = workOrderItems?.reduce((sum, item) => {
                return sum + item?.estimatedTime;
            }, 0);
            setTotalTime(totalMinutes)
        }
    }, [workOrderItems])

    useEffect(() => {
        if (selectedShift && totalTime && selectedSolution && selectedCustomer) {
            fetchCalenderShow()
        }
    }, [selectedShift, totalTime, selectedSolution, selectedCustomer])

    const handleContinue = () => {
        if (!selectedSlot) return;

        const fromMinutes = formatTime(highlightedSlot?.fromTime);
        const toMinutes = formatTime(highlightedSlot?.toTime);

        if (
            (!tempTime && !selectedTime) ||
            (!tempTime && selectedTime && (
                selectedSlot?.slot.FromTime !== highlightedSlot?.fromTime ||
                selectedSlot?.slot.ToTime !== highlightedSlot?.toTime ||
                selectedSlot?.team.teamId !== highlightedSlot?.teamId
            ))
        ) {
            showError("Please select the time");
            return;
        }

        // console.log(selectedSlot, "selected slot")

        // Construct date with selected time
        const selectedDate = new Date(selectedSlot.slot.FromTime);
        const [selectedHour, selectedMinute] = tempTime.split(":");
        selectedDate.setHours(parseInt(selectedHour, 10));
        selectedDate.setMinutes(parseInt(selectedMinute, 10));
        selectedDate.setSeconds(0);
        selectedDate.setMilliseconds(0);

        const selectedTimeInMs = selectedDate.getTime();
        const currentDateTime = new Date();
        const fromTime = new Date(selectedSlot.slot.FromTime).getTime();
        const toTime = new Date(selectedSlot.slot.ToTime).getTime();

        const isSameDay = selectedDate.toDateString() === currentDateTime.toDateString();

        // Future time check (if same day)
        if (isSameDay && selectedDate <= currentDateTime) {
            showError("Please select a future time");
            return;
        }

        // Time within slot range
        if (selectedTimeInMs < fromTime || selectedTimeInMs > toTime) {
            showError("Selected time is not within the range of this slot!");
            return;
        }

        // Check if estimated work fits within slot
        const totalEstimatedTimeInMs = (workOrderItems?.reduce((sum, item) => {
            return sum + item?.estimatedTime;
        }, 0) || 0) * 60000;

        const calculatedEndDateTime = new Date(
            selectedDate.getTime() + totalEstimatedTimeInMs
        );
        const slotEndTime = new Date(selectedSlot.slot.ToTime);

        if (calculatedEndDateTime > slotEndTime) {
            showError("The selected time and estimated work exceed the slot's end time!");
            return;
        }

        // Passed all checks
        if (tempTime) {
            setSelectedTime(tempTime);
        }

        setHighlightedSlot({
            teamId: selectedSlot.team.teamId,
            fromTime: selectedSlot.slot.FromTime,
            toTime: selectedSlot.slot.ToTime,
            selectedTime: tempTime,
        });

        toggleModal();
    };


    useEffect(() => {
        if (availableSlots) {
            setUniqueTeams(availableSlots?.reduce((acc, team) => {
                if (!acc?.some(t => t.teamId === team.teamId)) {
                    acc.push(team);
                }
                return acc;
            }, []))
        }
    }, [availableSlots]);

    const customOption = (props) => {
        const { data, innerRef, innerProps } = props;

        return (
            <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }} className='p-2'>
                <img src={`${process.env.REACT_APP_BASE_URL}${data.image}`} alt={data.label} style={{ width: 20, height: 20, marginRight: 10, borderRadius: "10px" }} />
                <span>{data.label}</span>
            </div>
        );
    };


    return (
        <div className="page-content">
            <Modal isOpen={modalOpen} toggle={toggleCustomerModal} className='modal-dialog-centered' backdrop="static">
                <ModalHeader toggle={toggleCustomerModal}>Filter Customers</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col sm={6}>
                            <label>Contract Number</label>
                            <Input type="text" name="contractNumber" placeholder='Enter Contract Number' value={searchFields.contractNumber} onChange={handleInputChange} />
                        </Col>
                        <Col sm={6}>
                            <label>Contact Number</label>
                            <Input type="text" name="contactNumber" placeholder='Enter Contact Number' value={searchFields.contactNumber} onChange={handleInputChange} />
                        </Col>
                        <Col sm={6}>
                            <label>Name</label>
                            <Input type="text" name="name" placeholder='Enter Name' value={searchFields.name} onChange={handleInputChange} />
                        </Col>
                        <Col sm={6}><Button color="primary" style={{ marginTop: "28px" }} onClick={handleSearch}>
                            Search
                        </Button></Col>
                    </Row>

                    <Select
                        options={customers?.Data?.map((customer) => ({
                            value: customer.customerId,
                            label: customer.customerNameEng,
                        }))}
                        isLoading={isCustomersLoading}
                        onChange={handleCustomerSelect}
                        placeholder="Select a Customer"
                        isClearable={true}
                        value={customer}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleCustomerModal}>
                        Close
                    </Button>
                    <Button color="primary" onClick={handleCustomerSelectSubmit} disabled={!customer}>
                        Continue
                    </Button>
                </ModalFooter>
            </Modal>
            <div className="d-flex justify-content-between align-items-center ms-3">
                <Breadcrumb
                    title="Create WorkOrder"
                    breadcrumbItems={[{ title: 'Dashboard', link: '/dashboard' }, { title: 'Create WorkOrder', link: '#' }]}
                />
                <Button className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center" onClick={() => navigate('/workorders')}>
                    Back
                </Button>
            </div>

            <div className="bg-white p-4" style={{ borderRadius: '8px' }}>
                {/* Customer Type Section */}
                <FormGroup tag="fieldset">
                    <h5>Customer Type</h5>
                    <div className='d-flex gap-3 align-items-center'>
                        <div>
                            <Label check>
                                <Input
                                    type="radio"
                                    value="new"
                                    checked={customerType === 'new'}
                                    onChange={handleCustomerTypeChange}
                                    style={{ border: "1px solid gray" }}
                                />
                                &nbsp; New Customer
                            </Label>
                        </div>
                        <div>
                            <Label check>
                                <Input
                                    type="radio"
                                    value="existing"
                                    checked={customerType === 'existing'}
                                    onChange={handleCustomerTypeChange}
                                    style={{ border: "1px solid gray" }}
                                />
                                &nbsp; Existing Customer
                            </Label>
                        </div>
                    </div>
                    {errors.customerType && <div className="text-danger">{errors.customerType}</div>}
                </FormGroup>

                <div className='d-flex  mb-3'>
                    <div>
                        <Select
                            id="solution"
                            options={solutions?.Data?.map(item => ({ label: item?.solutionName, value: item?.solutionId }))}
                            value={solutions?.Data?.map(item => ({ label: item?.solutionName, value: item?.solutionId }))?.find(option => option?.value == selectedSolution) || ""}
                            isLoading={isSolutionsLoading}
                            onChange={option => { setSelectedSolution(option?.value); }}
                            placeholder="Select Solution"
                            isClearable={true}
                            styles={{
                                container: (base) => ({
                                    ...base,
                                    minWidth: '200px',
                                }),
                            }}
                        />
                        {errors.solution && <div className="text-danger">{errors.solution}</div>}
                    </div>
                    <div className='ms-3'>
                        <label for="sebelUserId" className=''>Siebel User ID</label>
                        <Select
                            id="sebelUserId"
                            options={sebelUsers?.Data?.map(item => ({ label: item?.sabelUserId, value: item?.id }))}
                            value={sebelUsers?.Data?.map(item => ({ label: item?.sabelUserId, value: item?.id }))?.find(option => option?.value == sebelUserId || "")}
                            isLoading={sebelUsersLoading}
                            onChange={option => { setSebelUserId(option?.value || "") }}
                            placeholder="Select Siebel User ID"
                            isClearable={true}
                            styles={{
                                container: (base) => ({
                                    ...base,
                                    minWidth: '200px',
                                }),
                            }}
                        />
                        {errors.sebelUserId && <div className="text-danger">{errors.sebelUserId}</div>}
                    </div>
                    <div className='ms-3'>
                        <label>Remedy Number</label> <span className='text-danger'>*</span>
                        <Input
                            type="text"
                            value={remedyNumber}
                            onChange={(e) => setRemedyNumber(e.target.value)}
                            placeholder="Enter Remedy Number"
                            style={{ height: "38px", border: "1px solid lightgray", minWidth: "200px" }}
                        />
                        {errors.remedyNumber && <div className="text-danger">{errors.remedyNumber}</div>}
                    </div>
                </div>

                {/* Customer Selection Section */}
                {(customerType === 'existing' && selectedCustomer && selectedSolution && sebelUserId) && (
                    <Row className="customer-selector">
                        <Col md={6}>
                            <label>Customer </label> <span className='text-danger'>*</span>
                        </Col>
                    </Row>
                )}

                {(selectedCustomer && customerType === 'existing' && selectedSolution && sebelUserId) && (
                    <Row className="mb-3 mt-4 py-2 mx-1" style={{ border: '1px solid lightgray', borderRadius: '8px' }}>
                        <Col md={4} className="text-center d-flex justify-content-center align-items-center">
                            {/* Dummy Profile Picture */}
                            <img
                                src={DUMMY_USER_IMG}
                                alt="Profile"
                                className="rounded-circle"
                                style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                            />
                        </Col>
                        <Col md={8}>
                            <Row className="d-flex align-items-center">
                                <Col xs={6}>
                                    <div className="d-flex align-items-center gap-2">
                                        <div className="p-2" style={{ backgroundColor: 'lightgray', borderRadius: '50%' }}>
                                            <FaUserCircle size={25} />
                                        </div>
                                        <div className="d-flex justify-content-center align-items-center">
                                            <div className="mt-3">
                                                <h6 className="text-black" style={{ fontWeight: 'bold' }}>Customer Name: </h6>
                                                <p className="ms-1">{profileData?.customerNameEng}</p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={6}>
                                    <div className="d-flex align-items-center gap-2">
                                        <div className="p-2" style={{ backgroundColor: 'lightgray', borderRadius: '50%' }}>
                                            <RiContractLine size={23} />
                                        </div>
                                        <div className="d-flex justify-content-center align-items-center">
                                            <div className="mt-3">
                                                <h6 className="text-black" style={{ fontWeight: 'bold' }}>Contract Number: </h6>
                                                <p className="ms-1">{profileData?.contractNumber}</p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={6}>
                                    <div className='d-flex align-items-center gap-2' >
                                        <div className='p-2' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                                            <FaFileContract size={23} />
                                        </div>
                                        <div className='d-flex  justify-content-center align-items-center' >
                                            <div className='mt-3'>
                                                <h6 className='text-black' style={{ fontWeight: "bold" }}>contractId:  </h6>
                                                <p className='ms-1'>{profileData?.contractId}</p>
                                            </div>
                                        </div>

                                    </div>
                                </Col>

                                <Col xs={6}>
                                    <div className='d-flex align-items-center gap-2' >
                                        <div className='p-2' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                                            <FaHashtag size={23} />
                                        </div>
                                        <div className='d-flex  justify-content-center align-items-center' >
                                            <div className='mt-3'>
                                                <h6 className='text-black' style={{ fontWeight: "bold" }}>Suscriber Number:</h6>
                                                <p className='ms-1'>{profileData?.subscriberNumber}</p>
                                            </div>
                                        </div>

                                    </div>
                                </Col>

                                <Col xs={6}>
                                    <div className='d-flex align-items-center gap-2' >
                                        <div className='p-2' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                                            <FaPhoneAlt size={23} />
                                        </div>
                                        <div className='d-flex  justify-content-center align-items-center' >
                                            <div className='mt-3'>
                                                <h6 className='text-black' style={{ fontWeight: "bold" }}>Contact Number 1: </h6>
                                                <p className='ms-1'>{profileData?.contactNumber1}</p>
                                            </div>
                                        </div>

                                    </div>
                                </Col>

                                <Col xs={6}>
                                    <div className='d-flex align-items-center gap-2' >
                                        <div className='p-2' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                                            <FaPhoneAlt size={23} />
                                        </div>
                                        <div className='d-flex  justify-content-center align-items-center' >
                                            <div className='mt-3'>
                                                <h6 className='text-black' style={{ fontWeight: "bold" }}>Contract Number 2:  </h6>
                                                <p className='ms-1'>{profileData?.contactNumber2}</p>
                                            </div>
                                        </div>

                                    </div>
                                </Col>

                            </Row>
                            {/* Edit Button */}
                            <div className="text-end">
                                <Button color="primary" onClick={() => navigate(`/customerProfile/${selectedCustomer?.value}`, { state: { from: window.location.pathname } })}>
                                    View Profile
                                </Button>
                            </div>
                        </Col>
                    </Row>
                )}

                {/* Address Selection Section */}
                {(addressCards?.length > 0 && customerType === 'existing' && selectedCustomer && selectedSolution && sebelUserId) && (
                    <div className="address-cards mt-4">
                        <h5 className='ms-2'>Select an Address <span className='text-danger'>*</span></h5>
                        <div className="d-flex flex-wrap">
                            {addressCards?.map((address) => (
                                <Card
                                    key={address.customerAddressId}
                                    className={`m-2 ${selectedAddress?.customerAddressId === address.customerAddressId ? 'border-success' : 'border-secondary'}`}
                                    onClick={() => handleAddressSelect(address)}  // Entire Card is clickable
                                    style={{
                                        cursor: 'pointer',
                                        width: '200px',
                                        transition: 'box-shadow 0.3s ease',
                                        boxShadow: selectedAddress?.customerAddressId === address.customerAddressId
                                            ? '0 4px 8px rgba(0, 123, 255, 0.5)'
                                            : '0 2px 4px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    <CardBody>
                                        <FormGroup check>
                                            <Label check style={{ cursor: 'pointer' }}> {/* Ensure label is also clickable */}
                                                {/* Remove the Input's readOnly */}
                                                <Input
                                                    type="radio"
                                                    name="address"
                                                    checked={selectedAddress?.customerAddressId === address.customerAddressId}
                                                    onChange={() => { }} // No need for any logic on change
                                                    style={{ border: '1px solid gray' }}

                                                />
                                                <h5>Address #{address.customerAddressId}</h5>
                                                <p className="mb-0">{address.addressLine}, {address.area}</p>
                                                <p className="mb-0">{address.areaDescription}</p>
                                                <p>{address.landmark}</p>
                                            </Label>
                                        </FormGroup>
                                    </CardBody>
                                </Card>

                            ))}
                        </div>
                        {errors.selectedAddress && <div className="text-danger">{errors.selectedAddress}</div>}
                    </div>
                )}

                {(selectedCustomer && addressCards?.length <= 0 && customerType === 'existing' && selectedSolution && sebelUserId) && (
                    <div className="d-flex justify-content-center align-items-center mt-3" style={{ minHeight: "100px", border: "1px solid lightgray", borderRadius: "8px" }}>
                        <h6 className='text-center'>No Address Found</h6>
                    </div>
                )}

                {/* Work Order Items Section */}
                {(customerType === 'existing' && selectedCustomer && selectedSolution && sebelUserId) && <div>
                    <h5>Add Work Order Items</h5>
                    <div className="d-flex gap-2 align-items-center flex-wrap">
                        <div className="flex-grow-1">
                            <Select
                                options={catelogueItems}
                                value={selectedCatalogItem}
                                isLoading={isCatalogLoading}
                                onChange={setSelectedCatalogItem}
                                placeholder="Select Catalog Item"
                                isClearable={true}
                                components={{ Option: customOption }}
                            />
                        </div>
                        <div className="flex-grow-1">
                            <Input
                                type="number"
                                value={itemQuantity}
                                onChange={(e) => setItemQuantity(e.target.value)}
                                placeholder="Quantity"
                                style={{ height: "38px", border: "1px solid lightgray" }}
                            />
                        </div>

                        <div className="d-flex align-items-center">
                            <Button color="primary" onClick={handleAddWorkOrderItem}>
                                + Add Item
                            </Button>
                        </div>
                    </div>

                    {/* Serial Number Modal */}
                    <Modal isOpen={modalSerialNoOpen} toggle={() => setModalSerialNoOpen(!modalSerialNoOpen)} className='modal-dialog-centered' backdrop="static">
                        <ModalHeader toggle={() => setModalSerialNoOpen(false)}>Enter Serial Numbers</ModalHeader>
                        <ModalBody>
                            {serialNumbers.map((serial, index) => (
                                <Input
                                    key={index}
                                    type="text"
                                    value={serial}
                                    onChange={(e) => handleSerialNumberChange(index, e.target.value)}
                                    placeholder={`Serial Number ${index + 1}`}
                                    style={{ marginBottom: "10px" }}
                                />
                            ))}
                            {error && <div className="text-danger">{error}</div>}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={handleConfirmSerialNumbers}>
                                Confirm
                            </Button>
                            <Button color="secondary" onClick={() => setModalSerialNoOpen(false)}>
                                Cancel
                            </Button>
                        </ModalFooter>
                    </Modal>
                    {errors.workOrderItems && <div className="text-danger">{errors.workOrderItems}</div>}
                </div>}

                {/* Work Order Items Table */}
                {(workOrderItems.length > 0 && customerType === 'existing' && selectedCustomer && selectedSolution && sebelUserId) && (
                    <>
                        <Table responsive striped className='mt-3' style={{ border: "1px solid lightgray" }}>
                            <thead>
                                <tr>
                                    <th style={{ border: "1px solid lightgray" }}>Image</th>
                                    <th style={{ border: "1px solid lightgray" }}>Item</th>
                                    <th style={{ border: "1px solid lightgray" }}>time per item</th>
                                    <th style={{ border: "1px solid lightgray" }}>Time</th>
                                    <th style={{ border: "1px solid lightgray" }}>Serial Number</th>
                                    <th style={{ border: "1px solid lightgray" }}>Quantity</th>
                                    <th style={{ border: "1px solid lightgray" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {workOrderItems.map((item) => (
                                    <tr key={item.id}>
                                        <td className='border-1'>{<img src={`${process.env.REACT_APP_BASE_URL}${item?.image}`} style={{ objectFit: "cover", width: "50px", height: "50px", borderRadius: "25px" }} />}</td>
                                        <td className="text-center" style={{ border: "1px solid lightgray", verticalAlign: "middle" }}>{item.catalogItem.label}</td>
                                        <td style={{ verticalAlign: "middle" }} className="text-center">{(() => {
                                            const hours = Math.floor(item?.perTime / 60); // Calculate hours
                                            const minutes = item?.perTime % 60; // Calculate remaining minutes

                                            return hours > 0
                                                ? `${hours} hr${hours > 1 ? 's' : ''} ${minutes > 0 ? `${minutes} min${minutes > 1 ? 's' : ''}` : ''}`
                                                : `${minutes} min${minutes > 1 ? 's' : ''}`;
                                        })()}</td>
                                        <td className="text-center" style={{ border: "1px solid lightgray", verticalAlign: "middle" }}>{(() => {
                                            const hours = Math.floor(item?.estimatedTime / 60); // Calculate hours
                                            const minutes = item?.estimatedTime % 60; // Calculate remaining minutes

                                            return hours > 0
                                                ? `${hours} hr${hours > 1 ? 's' : ''} ${minutes > 0 ? `${minutes} min${minutes > 1 ? 's' : ''}` : ''}`
                                                : `${minutes} min${minutes > 1 ? 's' : ''}`;
                                        })()}</td>
                                        <td className="text-center" style={{ border: "1px solid lightgray", verticalAlign: "middle" }}>{item?.serialNumbers || 'N/A'}</td>
                                        <td className="text-center" style={{ border: "1px solid lightgray", verticalAlign: "middle" }}>{item.quantity}</td>
                                        <td className="text-center" style={{ border: "1px solid lightgray", verticalAlign: "middle" }}>
                                            <Button color="danger" onClick={() => handleDeleteWorkOrderItem(item.id)}>
                                                Delete
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <h6>Total Estimated Time: <span>{(() => {
                            const totalMinutes = workOrderItems?.reduce((sum, item) => {
                                return sum + item?.estimatedTime;
                            }, 0);
                            const hours = Math.floor(totalMinutes / 60); // Calculate hours
                            const minutes = totalMinutes % 60; // Calculate remaining minutes

                            return hours > 0
                                ? `${hours} hr${hours > 1 ? 's' : ''} ${minutes > 0 ? `${minutes} min${minutes > 1 ? 's' : ''}` : ''}`
                                : `${minutes} min${minutes > 1 ? 's' : ''}`;
                        })()}</span></h6>
                    </>
                )}

                {(customerType === 'existing' && selectedCustomer && selectedSolution && sebelUserId) &&
                    <div>
                        {/* Scheduled Dates and Time Section */}
                        <Row className="mt-3">
                            {/* <Col md={6}>
                                <label htmlFor="scheduledStartDateTime">Scheduled Start Date</label> <span className='text-danger'>*</span>
                                <Input
                                    type="date"
                                    value={scheduledStartDateTime}
                                    onChange={(e) => setScheduledStartDateTime(e.target.value)}
                                    min={new Date().toISOString().split('T')[0]}
                                    placeholder="Scheduled Start Date"
                                    style={{ height: "38px", border: "1px solid lightgray" }}
                                />
                                {errors.scheduledStartDateTime && <div className="text-danger">{errors.scheduledStartDateTime}</div>}
                            </Col> */}
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Select Shift</Label> <span className='text-danger'>*</span>
                                    <Select
                                        options={shifts?.Data?.map(item => ({ label: item?.shiftName, value: item?.shiftId }))}
                                        value={selectedShift}
                                        isLoading={shiftsLoading}
                                        onChange={setSelectedShift}
                                        placeholder="Select a Shift"
                                        isClearable={true}
                                    />
                                    {errors.selectedShift && <div className="text-danger">{errors.selectedShift}</div>}
                                </FormGroup>
                            </Col>
                            <Col>
                                <label htmlFor="scheduledStartDateTime">Scheduled Start Date</label> <span className='text-danger'>*</span>
                                {calendarLoading && <span className="ms-3"><ClipLoader size={12} color="#000" /> Fetching available dates...</span>}
                                <DatePicker
                                    selected={scheduledStartDateTime}
                                    onChange={(date) => {
                                        if (date) {
                                            const corrected = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
                                            setScheduledStartDateTime(corrected);
                                        } else {
                                            setScheduledStartDateTime(null);
                                        }
                                    }}
                                    filterDate={(date) => {
                                        // Disable booked, past dates, and all Fridays
                                        const today = new Date();
                                        today.setHours(0, 0, 0, 0);

                                        const isFriday = date.getDay() === 5; // 0=Sunday, 5=Friday

                                        return date >= today && !isBooked(date) && !isFriday;
                                    }}
                                    dayClassName={(date) => {
                                        const today = new Date();
                                        today.setHours(0, 0, 0, 0);

                                        const isFriday = date.getDay() === 5; // Fridays
                                        const isToday =
                                            date.getDate() === today.getDate() &&
                                            date.getMonth() === today.getMonth() &&
                                            date.getFullYear() === today.getFullYear();

                                        const isSelected =
                                            scheduledStartDateTime &&
                                            date.getDate() === scheduledStartDateTime.getDate() &&
                                            date.getMonth() === scheduledStartDateTime.getMonth() &&
                                            date.getFullYear() === scheduledStartDateTime.getFullYear();

                                        if (isFriday) return "friday-disabled"; //  Fridays
                                        if (isBooked(date)) return "booked-date"; // Booked dates
                                        if (isToday) return "today-highlight"; // Today
                                        if (isSelected) return "selected-date"; // Selected
                                        return undefined;
                                    }}
                                    className="form-control custom-datepicker"
                                    dateFormat="yyyy-MM-dd"
                                />

                            </Col>
                        </Row>

                        <Row className="pb-3">
                            <h5>Available Slots {(selectedTime && workOrderItems?.length > 0) && <span style={{ fontSize: "14px" }}> {`(Current Slot: ${selectedTime}- ${addMinutesToTime(selectedTime, workOrderItems?.reduce((sum, item) => {
                                return sum + item?.estimatedTime;
                            }, 0))})`}</span>}</h5>
                            <Col md={12} style={{ overflowX: "auto" }}>
                                {slotLoading ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100px" }}>
                                        <ClipLoader size={30} color="#0d6efd" />
                                    </div>
                                ) : (
                                    <Table hover>
                                        <thead>
                                            {/* <tr>
                                                <th>Team</th>
                                                <th>Available Slots</th>
                                            </tr> */}
                                        </thead>
                                    <tbody>
                                        {uniqueTeams?.map((team, index) => (
                                            <tr key={team.teamId}>
                                                <td className="" style={{ whiteSpace: "nowrap", verticalAlign: "middle" }}>{authUser?.userRole === "Super Admin" ? team?.teamName : authUser?.userRole === "Supervisor" ? team?.teamName : `Slot-${index + 1}`}</td>
                                                <td>
                                                    <div className="d-flex justify-content-start align-items-center gap-3">
                                                        {availableSlots?.filter((slot) => slot.teamId === team.teamId)
                                                            .reduce((uniqueSlots, slot) => {
                                                                if (
                                                                    !uniqueSlots?.some(
                                                                        (s) => s.FromTime === slot.FromTime && s.ToTime === slot.ToTime
                                                                    )
                                                                ) {
                                                                    uniqueSlots.push(slot);
                                                                }
                                                                return uniqueSlots;
                                                            }, [])
                                                            .map((slot, index) => (
                                                                <div
                                                                    key={index}
                                                                    onClick={() =>
                                                                        slot.TimeType !== "Engaged" ? handleSlotClick(team, slot) : ""
                                                                    }
                                                                    style={{
                                                                        backgroundColor:
                                                                            slot.TimeType === "Engaged" ? "lightgray" : "rgb(144, 238, 144)",
                                                                        padding: "7px",
                                                                        margin: "5px 0",
                                                                        cursor: slot.TimeType === "Engaged" ? "not-allowed" : "pointer",
                                                                        opacity: slot.TimeType === "Engaged" ? 0.5 : 1,
                                                                        border: highlightedSlot?.teamId === team.teamId &&
                                                                            highlightedSlot?.fromTime === slot.FromTime &&
                                                                            highlightedSlot?.toTime === slot.ToTime
                                                                            ? "2px solid blue"
                                                                            : "1px solid lightgray",
                                                                        borderRadius: "5px",
                                                                        whiteSpace: "nowrap",
                                                                        color: highlightedSlot?.teamId === team.teamId &&
                                                                            highlightedSlot?.fromTime === slot.FromTime &&
                                                                            highlightedSlot?.toTime === slot.ToTime
                                                                            ? "blue"
                                                                            : slot.TimeType === "Engaged" ? "black" : "white",
                                                                        fontSize: "12px"
                                                                    }}
                                                                >
                                                                    {new Date(slot.FromTime).toLocaleTimeString([], {
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                    })}{" "}
                                                                    -{" "}
                                                                    {new Date(slot.ToTime).toLocaleTimeString([], {
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                    })}
                                                                </div>
                                                            ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}

                                        {uniqueTeams?.length <= 0 && <div className='text-center'>No Slots Available</div>}

                                    </tbody>
                                </Table>
                                )}
                            </Col>
                        </Row>

                        <Modal isOpen={modal} toggle={toggleModal} centered backdrop="static">
                            <ModalHeader toggle={toggleModal}>Select Time</ModalHeader>
                            <ModalBody>
                                <div>
                                    Selected Slot : {new Date(selectedSlot?.slot.FromTime).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })}{" "}
                                    -{" "}
                                    {new Date(selectedSlot?.slot.ToTime).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })}
                                </div>
                                <div className='d-flex flex-column'>
                                    <label>Select Time:</label>
                                    <input
                                        type="time"
                                        value={
                                            highlightedSlot?.teamId === team?.teamId &&
                                                highlightedSlot?.fromTime === selectedSlot?.slot.FromTime &&
                                                highlightedSlot?.toTime === selectedSlot?.slot.ToTime
                                                ? tempTime || selectedTime : tempTime
                                        }
                                        onChange={handleTimeChange}
                                        min={formatTime(selectedSlot?.slot.FromTime)}
                                        max={formatTime(selectedSlot?.slot.ToTime)}
                                    />
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="primary" onClick={handleContinue}>
                                    Continue
                                </Button>
                                <Button color="secondary" onClick={toggleModal}>
                                    Cancel
                                </Button>
                            </ModalFooter>
                        </Modal>

                        {/* Customer Invoice Path Section */}
                        <Row className="mb-3">
                            <Col md={12}>
                                <FormGroup>
                                    <Label>Customer Invoice PDF</Label> <span className='text-danger'>*</span>
                                    <Input
                                        type="file"
                                        accept=".pdf"
                                        onChange={handleInvoiceFileChange}
                                        style={{ height: "38px", border: "1px solid lightgray" }}
                                    />
                                    {errors.customerInvoicePath && <div className="text-danger">{errors.customerInvoicePath}</div>}
                                    {customerInvoicePath && !errors.customerInvoicePath && (
                                        <div className="text-success mt-2">Selected File: {customerInvoicePath}</div>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>

                        {/* Agent Comments Section */}
                        <Row className="mb-3">
                            <Col md={12}>
                                <Label>Comment</Label>
                                <Input
                                    type="textarea"
                                    value={agentComments}
                                    onChange={(e) => setAgentComments(e.target.value)}
                                    placeholder="Enter Comment"
                                />
                                {errors.agentComments && <div className="text-danger">{errors.agentComments}</div>}
                            </Col>
                        </Row>
                    </div>}

                {/* Submit Button */}
                <div className="text-end">
                    <Button color="primary" onClick={handleSubmit} style={{ minWidth: "180px" }}>{loading ? <ClipLoader size={17} color="white" /> : "Create Work Order"}</Button>
                </div>
                {loader && (
                    <div className="bg-white p-4 rounded-3 mt-4" style={{ minHeight: '600px', position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 10 }}>
                        <Row className="mb-4">
                            <Col md={4}><Skeleton active paragraph={{ rows: 1 }} title={{ width: '40%' }} /></Col>
                        </Row>
                        <Row className="mb-4">
                            <Col md={6}><Skeleton active paragraph={{ rows: 1 }} title={{ width: '50%' }} /></Col>
                            <Col md={6}><Skeleton active paragraph={{ rows: 1 }} title={{ width: '50%' }} /></Col>
                        </Row>
                        <Row className="mb-4">
                            <Col md={12}><Skeleton active paragraph={{ rows: 2 }} title={{ width: '30%' }} /></Col>
                        </Row>
                        <Col md={12} className="mb-4">
                            <Skeleton.Button active block size="large" style={{ height: '200px' }} />
                        </Col>
                        <Row className="mb-4">
                            <Col md={6}><Skeleton active paragraph={{ rows: 1 }} title={{ width: '50%' }} /></Col>
                            <Col md={6}><Skeleton active paragraph={{ rows: 1 }} title={{ width: '50%' }} /></Col>
                        </Row>
                        <Skeleton active paragraph={{ rows: 4 }} title={{ width: '20%' }} />
                    </div>
                )}
            </div>
        </div >
    );
};

export default CreateWorkOrder;
